<script>
  import EventEntry from "./EventEntry.svelte";
  export let lenex;

  let athletes;
  $: if (lenex) {
    athletes = lenex.rawLenexData.meets
      ?.flatMap(meet => meet.clubs)
      .filter(c => c != null)
      .flatMap(
        club => club.athletes?.map(athlete => ({ ...athlete, club })) ?? []
      );
  }
</script>

<style>
  .athlete-list {
    list-style: none;
    padding: 0px;
  }
  .entry-list {
    list-style: none;
    padding: 0px;
    margin: 1rem;
  }
  .entry-list > li {
    margin: 0.5rem;
  }
  .athlete-list-item {
    page-break-inside: avoid;
  }
</style>

<ul class="athlete-list">
{#each athletes as athlete}
<li class="athlete-list-item">
  <strong>{athlete.firstname} {athlete.lastname}</strong> <i>{athlete.birthdate}</i>

  <ol class="entry-list">
    {#each (athlete.entries) || [] as entry}
      <li><EventEntry entry={entry} event={lenex.getEventById(entry.eventid)} courseInfo={lenex.meetCourse}/>
    </li>
    {:else}
      <li>No entries</li>
    {/each}
  </ol>
</li>
{/each}
</ul>